/*
 * Put-profile.ts
 * Description: Includes the declaration of a function
 * to update user profile
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing variables
import {APIURL, EmailTaken, OldPassword} from '../variables';
// Importing interface
import {Profile} from '@/ts/profile/validate-profile';

/**
 * Updating user profile
 *
 * @param {String[]} errors - register errors
 * @param {Profile} data - user profile data
 */
export function putProfile(errors: string[], data: Profile) {
    const jwt = localStorage.getItem('jwt');
    // Creating a new instance of Promise to make JavaScript work synchronous
    return new Promise ((resolve, reject) => {
        Axios({
            url:  APIURL + 'auth/user',
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then((response) => {
            const user = response.data.data.attributes;
            // Setting up the new name in local storage
            localStorage.setItem('user', user.first_name + ' ' + user.last_name);
            resolve();
        }).catch((error) => {
            const err = error.response.data;
            // Checking if there are errors with the password
            if (Array.isArray(err.errors)) {
                for (const temp of err.errors) {
                    if (temp.message === 'The old password is incorrect!') {
                        // Displaying errors
                        errors.push(OldPassword);
                    } else {
                        errors.push(temp.message);
                    }

                }
                // Checking if there are errors with the email
                if (Array.isArray(err.errors.email)) {
                    for (const temp of err.errors.email) {
                        if (temp === 'The email has already been taken.') {
                            errors.push(EmailTaken);
                        } else {
                            errors.push(temp);
                        }

                    }
                }
            }
            reject();
        });
    });
}
